export const NavigationI18n = {
    not_found_error: 'Erreur 404',
    oups           : 'Oops! la page que vous cherchez nexiste pas!'
}